import { serverTimestamp } from "firebase/firestore";
import { utcTimestampToLocal, localToUtcTimestamp } from "../../../utils/dateTimeUtils";

export default class Calendar {
  constructor(data = {}) {
    this.id = data.id;
    this.name = data.name;
    this.isActive = data.isActive;
    this.startDate = data.startDate;
    this.endDate = data.endDate;
    this.localAuthorityId = data.localAuthorityId;
    this.type = data.type;

    this.metadata = {
      createdAt: utcTimestampToLocal(data.metadata.createdAt),
      updatedAt: utcTimestampToLocal(data.metadata.updatedAt),
      updatedBy: data.metadata.updatedBy,
      createdBy: data.metadata.createdBy,
    };
  }

  static toJSON(data) {
    const now = serverTimestamp();

    return {
      id: data.id,
      name: data.name || "",
      isActive: true,
      startDate: data.startDate || "",
      endDate: data.endDate || "",
      localAuthorityId: data.localAuthorityId || "",
      type: data.type || "",
      metadata: {
        createdAt: now,
        updatedAt: now,
        updatedBy: data.metadata.updatedBy || "",
        createdBy: data.metadata.updatedBy || "",
      },
    };
  }

  static toJsonUpdate(data) {
    const baseData = { ...data };
    baseData.metadata.updatedAt = serverTimestamp();

    if (data.metadata.createdAt) {
      baseData.metadata.createdAt = localToUtcTimestamp(data.metadata.createdAt);
    }

    return baseData;
  }
}
